module.exports = __webpack_public_path__ + "static/src/content/images/trapeze artist.a159f77.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/trapeze artist.png
// module id = b1q8
// module chunks = 0